<template>
  <detail-layout>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.code')}}</label>
              <el-form-item prop="Code">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Code"
                  :disabled="isRoleUserConsultaProvider"
                />
              </el-form-item>
            </div>
          
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="Name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Name"
                  maxlength='100'
                  :disabled="isRoleUserConsultaProvider"
                />
              </el-form-item>
            </div>
                
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('app.role', 1)}}</label>
              <el-form-item prop="Role">
                <el-select class="w-full" 
                  clearable
                  filterable
                  v-model="form.Role" 
                  :disabled="isRoleUserConsultaProvider">
                  <el-option
                    v-for="opt in tiposRolesAdministrativeCentersFB2B"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
  </detail-layout>
</template>

<script>

import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'


export default {
  name: 'detalle-administrative-centre',
  components: {
    DetailLayout,
  },
  props: {
    form: {
      type: Object,
    },
  },
  data: function () {
    return {
      codeMaxLength: 10,
      rules: {
        Code: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.Code) {
                callback(new Error(i18n.t('app.fill_data')))
              } else if (this.form.Code.length > this.codeMaxLength) {
                callback(new Error(i18n.t('validation.length_max', { maxLength: this.codeMaxLength })))
              } else if (!new RegExp(`^\\d{1,${this.codeMaxLength}}$`).test(this.form.Code)) {
                callback(new Error(i18n.t('validation.only_digits')))
              } else {
                callback()
              }
            }
          },
        ],
        Role: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
      },
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    tiposRolesAdministrativeCentersFB2B: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B']
    },
  },
  methods: {
    resetForm: function () {
      this.$refs.ruleForm.resetForm()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        callback(valid)
      })
    },
  },
}
</script>

<style>

</style>
